import { Box } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants';

export const ProductItemFlowContainer = Box.withConfig({
  width: 'full',
  backgroundColor: primitive.$white,
});
